import { AlertProps, Breakpoint, Dialog, DialogActions, DialogContent, DialogProps, IconButton } from '@mui/material';
import { CloseIcon } from '../../controls/MaterialUIIcons';
import { ButtonTypography, GreyOutlinedButton } from '../Buttons/buttons';
import { EditDialogTitle, PaperComponent } from '../EditDialog/EditDialog';
import { ResizableBox } from 'react-resizable';
import * as React from 'react';
import { useCallback, useState } from 'react';
import { useResizeStyles } from '../EditDialog/stylesDialog';
import clsx from 'clsx';

export type MessageDialogState = {
  open: boolean;
  width?: string;
  content: string | JSX.Element;
  title?: string;
  severity: AlertProps['severity'] | undefined;
};

export function initDefaultMessageDialogState(): MessageDialogState {
  return {
    open: false,
    severity: 'info',
    content: <></>,
  };
}

interface MessageDialogProps {
  title?: string | JSX.Element;
  children: any;
  open: boolean;
  testId?: string;
  onClose: () => void;
  closeText?: string;
  showCloseInTheTitle?: boolean;
  buttons?: JSX.Element;
  width?: number;
  height?: number;
  maxHeight?: false | Breakpoint | undefined;
  resizableBoxClassName?: string;
}


export const MessageDialog = (
  props: Omit<DialogProps, 'title'> & MessageDialogProps
) => {
  const { title, children, open, onClose, testId = '', closeText, buttons, showCloseInTheTitle = false, classes, resizableBoxClassName } = props;
  const { height, width } = props;
  const { resizable } = useResizeStyles();
  const [resizeState, setResizeState] = useState({ height: 0, width: 0 });

  const measuredRef = useCallback((node: HTMLDivElement) => {
    if (node) {
      const newHeight = height ?? node.scrollHeight + 129;
      const newWidth = width ?? node.scrollWidth;
      setResizeState(prev => {
        return {
          height: newHeight,
          width: newWidth
        };
      });
    }
  }, [height, width]);
  return (
    <Dialog
      open={open}
      PaperComponent={PaperComponent}
      classes={classes}
      keepMounted
      onClose={() => onClose()}
      aria-labelledby='draggable-dialog-title'
    >
      <ResizableBox
        {...resizeState}
        className={clsx(resizable, resizableBoxClassName)}
      >
        <>
          <EditDialogTitle
            style={{
              fontSize: '16px',
              display: 'Flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
            id='draggable-dialog-title'
          >
            {title}
            <IconButton
              aria-label='close'
              onClick={onClose}
              hidden={!showCloseInTheTitle}
              size='medium'
              sx={{
                width: 40,
                height: 40,
              }}
            >
              <CloseIcon style={{ color: 'white', alignSelf: 'flex-end' }} />
            </IconButton>
          </EditDialogTitle>
          <DialogContent ref={measuredRef} style={{ display: 'flex', flexGrow: 1, paddingTop: '.5rem' }}>
            {children}
          </DialogContent>
          <DialogActions hidden={showCloseInTheTitle}>
            {buttons}
            <GreyOutlinedButton
              test-id={testId + '-lukk-btn'}
              onClick={onClose}
            >
              <ButtonTypography>{closeText ?? 'Lukk'}</ButtonTypography>
            </GreyOutlinedButton>
          </DialogActions></>
      </ResizableBox>
    </Dialog>
  );
};
